export enum DevicesAndStore {
  ANDROID = 'android',
  ANDROID_STORE = 'https://play.google.com/store/apps/details?id=com.keeptruckin.android.fleet',
  IPHONE = 'iphone',
  IPHONE_STORE = 'https://apps.apple.com/us/app/keeptruckin-fleet/id1531641455',
}